/**
 * Custom error thrown when a user is redirected due to unauthorized access (401).
 * Calling code can catch this to distinguish logout redirects from other errors.
 */
export class UnauthorizedError extends Error {
  constructor(
    message: string = 'User was redirected due to unauthorized access',
  ) {
    super(message);
    this.name = 'UnauthorizedError';
  }
}

/**
 * HTTP error with status code for API error handling.
 *
 * Produced by `errorMappingInterceptor` from raw `HttpErrorResponse`s and thrown
 * to ApiService callers, which catch it to inspect `status`.
 */
export class HttpError extends Error {
  constructor(
    public status: number,
    message?: string,
  ) {
    super(message || `HTTP error! status: ${status}`);
    this.name = 'HttpError';
  }
}
